class ModelValidator {
    constructor(rules) {
        this.rules = this.flattenRules(rules);
    }

    flattenRules(rules) {
        if (Array.isArray(rules))
            return rules;
        else {
            const flatObj = {};
            for (let prop in rules) {

                if (Array.isArray(rules[prop])) {
                    flatObj[prop] = rules[prop];
                } else {
                    const flatChild = this.flattenRules(rules[prop]);
                    for (let addProp in flatChild) {
                        flatObj[prop + '.' + addProp] = flatChild[addProp];
                    }
                }

            }
            return flatObj;
        }

    }

    validate(model, attrs) {
        const errors = [];
        let valid = true;
        const attributes = attrs || Object.keys(this.rules);
        for (let ruleAttr of attributes) {
            const rules = this.rules[ruleAttr] || [];
            let paths = [ruleAttr];
            if (ruleAttr.indexOf('*') !== -1) {
                paths = this.getAsteriksPaths(model, ruleAttr);
            }
            for (let path of paths) {
                const validationObj = _.get(model, path, null);

                rules.forEach(rule => {
                    const validationResult = rule(validationObj, model);
                    if (validationResult !== true) {
                        valid = false;
                        if (typeof validationResult === 'string') {
                            errors.push({attr: path, message: validationResult})
                        } else {
                            errors.push(validationResult)
                        }
                    }
                })
            }
        }

        return {valid,errors};
    }

    getAsteriksPaths(model, path) {
        const asteriksIndex = path.indexOf('*');
        if (asteriksIndex >= 0) {
            const paths = [];
            const leftPath = path.substring(0, asteriksIndex - 1);
            const rightPath = path.substring(asteriksIndex + 2);
            const firstParent = _.get(model, leftPath);
            for (let key in firstParent) {
                paths.push(...this.getAsteriksPaths(model, leftPath + '.' + key + '.' + rightPath));
            }
            return paths;
        } else {
            return [path];
        }
    }
}

export default ModelValidator;
